import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { DatasearchService } from '../../_services/datasearch.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-press-release',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, NgIf, DatePipe, RouterLink],
  templateUrl: './press-release.component.html',
  styleUrl: './press-release.component.scss'
})
export class PressReleaseComponent {
  transparent = false;
  pressReleaseList: any = [];
  logoBaseUrl = '../../../assets/DummyImages/logo/';
  press_release_image_url = '';
  head: any[] = [];
  currentPage: string = 'press-release';
  constructor(private datasearch: DatasearchService, private router: Router) {
    this.press_release_image_url = this.datasearch.ApiUrl + '/uploads/press-release-images/';
  }

  ngOnInit() {
    this.getPressRelease();
    this.getHeading();

  }

  getPressRelease() {
    // this.pressReleaseList.push({_id: 1, title: 'Section 1.10.33 of de Finibus Bonorum et Malorum, written by Cicero in 45 BC', logo: '2.png', 
    // description: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est...',
    // date: '22-01-2024'});
    // this.pressReleaseList.push({_id: 2, title: 'Section 1.10.33 of de Finibus Bonorum et Malorum, written by Cicero in 45 BC', logo: '2.png', 
    // description: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est...',
    // date: '22-01-2024'});
    // this.pressReleaseList.push({_id: 3, title: 'AgbioInvestor and ChemRobotics Announce Global Collaboration', logo: '3.png', 
    // description: 'AgbioInvestor and ChemRobotics are pleased to announce the formation of a new global alliance involving ChemRobotics&rsquo; pharmaceutical intelligence platform. Through this agreement, AgbioInvestor will undertake the distribution and sale of ChemRobotics&rsquo; global...',
    // date: '22-01-2024'});
    // this.pressReleaseList.push({_id: 4, title: 'Section 1.10.33 of de Finibus Bonorum et Malorum, written by Cicero in 45 BC',
    // logo: '2.png', 
    // description: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est...',
    // date: '22-01-2024'});
    // this.pressReleaseList.push({_id: 5, title: 'Section 1.10.33 of de Finibus Bonorum et Malorum, written by Cicero in 45 BC', logo: '5.png', 
    // description: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est...',
    // date: '22-01-2024'});
    // this.pressReleaseList.push({_id: 6, title: 'AgbioInvestor and ChemRobotics Announce Global Collaboration', logo: '6.png', 
    // description: 'AgbioInvestor and ChemRobotics are pleased to announce the formation of a new global alliance involving ChemRobotics&rsquo; pharmaceutical intelligence platform. Through this agreement, AgbioInvestor will undertake the distribution and sale of ChemRobotics&rsquo; global...',
    // date: '22-01-2024'});  
    this.datasearch.getPressReleases().subscribe((res) => {
      // Filter only active press releases
      this.pressReleaseList = res.data.filter((item: any) => item.isActive === true);
    },
      (error) => {
        // console.log(error);      
      });
  }

  getPressReleaseImageUrl(data: any): string {
    const filename = data.press_release_image || data.logo || data.image;
    if (!filename) {
      return '';
    }
    if (filename.toString().startsWith('http')) {
      return filename;
    }
    return this.press_release_image_url + filename;
  }

  goToPressReleaseDetail(_id: any) {
    this.router.navigate(['/press_release_details', _id]);
  }
  getHeading() {
    this.datasearch.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
}
